<template>
  <div>
    <ViewTemplateConfiguration :templateList="templateList" :actions="actions">
      <div slot="content-buttons">
        <Button _key="btnProductTypeCreate" title="Tipo" classIcon="fas fa-plus-circle" type="primary" size="small"
          :clicked="create" />
      </div>
    </ViewTemplateConfiguration>
    <Modal title="Tipo" :width="700" :height="250" v-show="showModal('productTypeCreateUpdate')">
      <TypeProductCreateUpdate />
    </Modal>
  </div>
</template>

<script>
import ViewTemplateConfiguration from "@nixweb/nixloc-ui/src/component/template/ViewTemplateConfiguration";
import TypeProductCreateUpdate from "../../../components/modules/stock/type-product/TypeProductCreateUpdate.vue";

import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "ProductTypeView",
  components: {
    ViewTemplateConfiguration,
    Button,
    Modal,
    TypeProductCreateUpdate,
  },
  data() {
    return {
      templateList: {
        urlGetApi: "/api/v1/stock/type-product/get-all",
        urlDeleteAllApi: "/api/v1/stock/type-product/delete",
        headerTable: [
          {
            field: "name",
            title: "Nome",
            type: "link",
            iconSearch: true,
            eventName: "productTypeUpdate",
          },
          {
            field: "typeName",
            title: "Tipo",
            type: "text",
            iconSearch: false,
          },
        ],
      },
      actions: [
        { type: "delete", title: "Remover", description: "Remover", url: "/api/v1/stock/type-product/delete", method: "delete", },
      ],
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "openModal", "removeLoading"]),
    create() {
      this.openModal("productTypeCreateUpdate");
      this.addEvent({ name: "productTypeCreate" });
      this.removeLoading(["btnProductTypeCreate"]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "productTypeUpdate") this.openModal("productTypeCreateUpdate");
      },
      deep: true,
    },
  },
};
</script>
